import axiosClient from './axiosClient';

const cartApi = {
  create: (param) => {
    const url = `/cart`;
    return axiosClient.post(url, param);
  },

  update: (id, param) => {
    const url = `/cart/${id}`;
    return axiosClient.put(url, param);
  },

  delete: (id) => {
    const url = `/cart/${id}`;
    return axiosClient.delete(url);
  },

  getCartDetailByUser: (id) => {
    const url = `/cart/get-user-cart/${id}`;
    return axiosClient.get(url);
  },

  getUnitByIntake: (id) => {
    const url = `/course-units/get-intake-units/${id}`;
    return axiosClient.get(url);
  },
  createWishList: (param) => {
    const url = `/wish-list`;
    return axiosClient.post(url, param);
  },
  updateWishList: (param, id) => {
    const url = `/wish-list/${id}`;
    return axiosClient.put(url, param);
  },
  deleteWishList: (id) => {
    const url = `/wish-list/${id}`;
    return axiosClient.delete(url);
  },
  getWishListByUserId: (id) => {
    const url = `/wish-list/get-user-wish-list/${id}`;
    return axiosClient.get(url);
  },
  loginWishListToUser: (id, param) => {
    const url = `/wish-list/update-user-wish-list/${id}`;
    return axiosClient.post(url, param);
  },
  toProceedPayment: (param) => {
    const url = '/payments';
    return axiosClient.post(url, param);
  },
  paymentHistory: (id, param) => {
    const url = `/payments/get-user-payment/${id}?page=${param.page}&rowPerPage=${param.rowPerPage}`;
    return axiosClient.get(url);
  },
  freeUnitPayment: (param) => {
    const url = '/payments/free-payment';
    return axiosClient.post(url, param);
  },
  getPaymentById: (id) => {
    const url = `/payments/${id}`;
    return axiosClient.get(url);
  },
  stripeCheckoutCreatePayment: (param) => {
    const url = '/stripe/checkout-create-payment';
    return axiosClient.post(url, param);
  },
  stripeCheckoutFreeCart: (param) => {
    const url = '/courses/cart-intake';
    return axiosClient.post(url, param);
  },
};

export default cartApi;
